import { AxiosResponse, AxiosInstance } from 'axios';

enum CabinetPoints {
  GET_PROGRAMS = 'profile/order/recommendations',
}

type Value = (value: any) => Promise<any>;

interface ICabinetService {
  [index: string]: Value;
}

export { CabinetPoints, AxiosResponse, AxiosInstance, ICabinetService };



// WEBPACK FOOTER //
// ./src/services/cabinet/types.ts